// Format selector component for choosing output format
import React from 'react';
import { Box, Text, HStack, Button } from '@chakra-ui/react';
import { OutputFormat } from '../types';

interface FormatSelectorProps {
  outputFormat: OutputFormat;
  onFormatChange: (format: OutputFormat) => void;
}

const FORMATS: OutputFormat[] = ['jpeg', 'png', 'webp'];

export const FormatSelector: React.FC<FormatSelectorProps> = ({ outputFormat, onFormatChange }) => {
  return (
    <Box
      bg="background.secondary"
      borderRadius="xl"
      p={5}
      border="1px solid"
      borderColor="border.default"
    >
      <Text
        fontSize="xs"
        fontWeight="semibold"
        color="text.secondary"
        textTransform="uppercase"
        letterSpacing="wider"
        fontFamily="secondary"
        mb={4}
      >
        Format
      </Text>

      <HStack spacing={2}>
        {FORMATS.map((format) => (
          <Button
            key={format}
            flex={1}
            py={2}
            bg={outputFormat === format ? 'brand.primary.DEFAULT' : 'transparent'}
            color={outputFormat === format ? 'white' : 'text.primary'}
            border="1px solid"
            borderColor={outputFormat === format ? 'brand.primary.DEFAULT' : 'border.default'}
            borderRadius="lg"
            fontWeight="semibold"
            fontFamily="secondary"
            _hover={{
              bg: outputFormat === format ? 'brand.primary.hover' : 'background.tertiary',
            }}
            onClick={() => onFormatChange(format)}
            textTransform="uppercase"
            fontSize="sm"
          >
            {format}
          </Button>
        ))}
      </HStack>
    </Box>
  );
};
